// extracted by mini-css-extract-plugin
module.exports = {"main":"QsrOrderCreateStatus_main__HWxYf","status":"QsrOrderCreateStatus_status__uh2Bf"};